import React from 'react';
import cx from 'classnames';
import pick from 'lodash/pick';
import tinyColor from 'tinycolor2';
import ContentBadges from '../lib/ContentBadges.js';
import ContentButtons from '../lib/ContentButtons.js';
import ContentIcon from '../ContentIcon/index.js';
import ContentInformation from '../lib/ContentInformation.js';
import ContentPreviewIndicator from '../lib/ContentPreviewIndicator.js';
import ContentProgress from '../lib/ContentProgress.js';
import contentType, { defaultContentType } from '../lib/types/content.js';
import withAutomaticColorCalculation from '../lib/withAutomaticColorCalculation.js';
import SuperbadgeSetLabel from '../lib/SuperbadgeSetLabel.js';

function ContentHeader({
  className,
  content,
  buttons,
  actions,
  user,
  labels,
  superbadgeSet,
  locks
}) {
  const DARKEN_BY = 8;
  const borderTopColor = () => content.type === "trail" ? tinyColor(content.color).darken(DARKEN_BY).toString() : content.color;
  const topStyles = {
    height: "5rem",
    backgroundColor: borderTopColor()
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className, "tds-content-header slds-text-body_small tds-color_meteorite slds-is-relative tds-box-shadow_small")
  }, /*#__PURE__*/React.createElement("div", {
    className: "slds-grid slds-grid_vertical-align-center",
    style: topStyles
  }, content.preview && /*#__PURE__*/React.createElement(ContentPreviewIndicator, {
    labels: labels,
    id: content.apiName,
    namespace: content.preview.namespace,
    releasedAt: content.preview.releasedAt,
    updatedAt: content.preview.updatedAt
  }), /*#__PURE__*/React.createElement("div", {
    className: "slds-grid slds-grid_align-spread slds-container_center slds-container_x-large slds-p-horizontal_large slds-grow"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "-3.6rem"
    }
  }, /*#__PURE__*/React.createElement(ContentIcon, {
    content: {
      ...pick(content, ["color", "image", "trailmix", "type", "unitCount"]),
      path: content.path
    },
    user: pick(user, ["finishedAt", "unlocked", "completedCount"]),
    noLink: true,
    locks: locks
  })), /*#__PURE__*/React.createElement("div", {
    className: "slds-grid"
  }, superbadgeSet && /*#__PURE__*/React.createElement(SuperbadgeSetLabel, superbadgeSet), actions && actions.map((action, i) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement("div", {
    className: "slds-m-left_xx-small",
    key: i
  }, action))))), /*#__PURE__*/React.createElement("div", {
    className: "slds-container_center slds-container_x-large slds-p-horizontal_large slds-p-top_large"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slds-float_right slds-text-align_right slds-m-left_small"
  }, /*#__PURE__*/React.createElement(ContentBadges, {
    content: content,
    user: user,
    labels: labels
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "1.25rem"
    }
  }, /*#__PURE__*/React.createElement(ContentInformation, {
    content: content,
    className: "slds-m-bottom_medium",
    noLink: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "slds-grid slds-p-bottom_large"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slds-grow tds-content__buttons"
  }, buttons && /*#__PURE__*/React.createElement(ContentButtons, {
    buttons: buttons
  })), /*#__PURE__*/React.createElement("div", {
    className: "slds-grow-none slds-grid slds-grid_vertical-align-center slds-text-align_right"
  }, /*#__PURE__*/React.createElement(ContentProgress, {
    content: content,
    user: user,
    labels: labels,
    expanded: true
  })))));
}
ContentHeader.displayName = "ContentHeader";
const WrappedContentHeader = withAutomaticColorCalculation(ContentHeader);
WrappedContentHeader.propTypes = contentType;
WrappedContentHeader.defaultTypes = defaultContentType;
var WrappedContentHeader$1 = WrappedContentHeader;

export { WrappedContentHeader$1 as default };
